import { previewIssue, exitPreview } from "@/lib/glossyApi";
import { cycleIndexFor, editionLabel } from "@/lib/issue";

// Gold bar shown ONLY while the editor is dress-rehearsing a future edition. Readers never see this.
export default function EditionPreviewBar() {
  const pv = previewIssue();
  if (!pv) return null;
  const label = editionLabel(cycleIndexFor(pv + "T12:00:00Z"));
  return (
    <div className="fixed bottom-0 inset-x-0 z-[70] bg-gloss-gold text-ink px-4 py-2.5 flex flex-wrap items-center justify-center gap-x-5 gap-y-1 shadow-[0_-4px_20px_rgba(0,0,0,0.25)]" data-testid="edition-preview-bar">
      <span className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.25em]">Dress rehearsal — {label} · only you can see this</span>
      <button onClick={exitPreview} className="font-mono text-[10px] uppercase tracking-[0.2em] border border-ink px-3 py-1 hover:bg-ink hover:text-cream transition-colors" data-testid="exit-preview">
        Exit preview
      </button>
    </div>
  );
}
